import clone from 'lodash/clone';
import curry from 'lodash/curry';
import forEach from 'lodash/forEach';
import head from 'lodash/head';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import replace from 'lodash/replace';
import trim from 'lodash/trim';
import filter from 'lodash/filter';

import get from 'lodash/fp/get';

const fp = {
  get,
};

export {
  clone,
  curry,
  forEach,
  head,
  isArray,
  isEmpty,
  map,
  replace,
  trim,
  fp,
  filter,
};
